import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
export const REVERT_NOTIFICATION_SUCCESS_TOAST_TEST_ID = 'revert-notification-setting-success-toast';
export const useRevertNotificationSetting = function useRevertNotificationSetting() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { mutate, isLoading, error } = useMutationState({
        mutationFn: (args)=>api.notification.revertNotificationSetting(args),
        toasts: {
            successMessage: commonTexts.toasts.notificationSettingsRevertedSuccessfully(),
            successTestId: REVERT_NOTIFICATION_SUCCESS_TOAST_TEST_ID
        },
        onSuccess
    });
    return {
        revert: mutate,
        isLoading,
        error
    };
};
